import React from "react";

import Divider from "@components/Divider";
import Text, { FontFamilyVariant, TextType } from "@components/Text";

import "./styles.less";

interface IProps {
    text: string;
    className?: string;
}

export default function ORDivider(props: IProps) {
    const { className, text } = props;
    const customClassName = ["wf_or_divider", className].join(" ");
    return (
        <div className={customClassName}>
            <Divider className="divider" />
            <Text 
                className="div_text"   
                fontFamilyVariant={FontFamilyVariant.regular1}
                text={text}
                textType={TextType.h8}
            />
            <Divider className="divider" />
        </div>
    );
}

